/**
 * Event-related constants and configuration
 */

// Available sports for events
export const SPORTS = [
  "Football", 
  "Basketball", 
  "Baseball", 
  "Soccer", 
  "Volleyball", 
  "Wrestling", 
  "Track & Field", 
  "Other"
];

// Event types with descriptions
export const EVENT_TYPES = [
  { value: "tournament", label: "Tournament", description: "Bracket-based competition with elimination rounds" },
  { value: "all_star", label: "All-Star Game", description: "Two custom teams with preset or TBD rosters" },
  { value: "showcase", label: "Showcase", description: "Schedule of games with multiple teams (non-tournament)" }
];

// Default form data for new events
export const DEFAULT_EVENT_FORM = {
  name: "",
  slug: "",
  custom_url_path: "",
  event_type: "tournament",
  description: "",
  sport: "Football",
  logo_url: "",
  color: "#FFFFFF",
  start_date: "",
  end_date: "",
  location: "",
  venue: "",
  sponsors: [],
  broadcast_ids: [],
  is_published: false,
  brackets_enabled: false,
  flagship_sponsor_enabled: false,
  flagship_sponsor_name: "",
  flagship_sponsor_logo_url: "",
  all_star_teams: [
    { name: "Team A", abbreviation: "TMA", color: "#1a1a1a", logo_url: "", roster: [] },
    { name: "Team B", abbreviation: "TMB", color: "#003087", logo_url: "", roster: [] }
  ]
};

// Bracket size options
export const BRACKET_SIZES = [4, 8, 16, 32];

// Default bracket template
export const DEFAULT_BRACKET = {
  id: "",
  name: "Main Bracket",
  size: 8,
  teams: [],
  games: [],
  stats_link: ""
};
